import React, { Component } from "react";
import { connect } from "react-redux";
import {
    fetchRedemptions as fetch,
    resetRedemptions as reset,
    setRedemptionsPagination as setPagination
} from "../../actions/redemptions";
import { setLocales } from "../../actions";
class TableRedemption extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }
    handleChange(e) {
        e.preventDefault();
        const { value } = e.target;
        const payload = {
            page: 1,
            perPage: parseInt(value)
        };
        this.props.setPagination(payload);
        this.props.fetch();
    }

    handleClick = page => e => {
        e.preventDefault();
        const payload = {
            page: parseInt(page)
        };
        this.props.setPagination(payload);
        this.props.fetch();
    };

    componentWillMount() {
        this.props.fetch();
    }

    componentWillUnmount() {
        this.props.reset();
    }

    render() {
        const {
            count,
            rows,
            pagination: { page, perPage, start, end }
        } = this.props.redemptions;
        const { locales } = this.props.lang;
        const moment = require("moment");
        return (
            <div className="" id="riwayat-transaksi">
                <div className="header">
                    <div className="row">
                        <div className="col-xs-6">
                            {/* <input type="text" placeholder="Search" className="form-search" onChange={ e => console.log(e) }/> */}
                        </div>
                        <div className="col-xs-6 text-right">
                            <label htmlFor="">
                                {
                                    this.props.lang[this.props.lang.locales]
                                        .misc.table.page
                                }
                                <select
                                    defaultValue={perPage}
                                    onChange={this.handleChange}
                                >
                                    <option value="25"> 25 </option>
                                    <option value="50"> 50 </option>
                                    <option value="100"> 100 </option>
                                    <option value="200"> 200 </option>
                                </select>
                            </label>
                        </div>
                    </div>
                </div>
                <table width="100%" className="table">
                    <thead>
                        <tr>
                            <th>
                                {
                                    this.props.lang[this.props.lang.locales]
                                        .contents.claim.redeemInfo.table.date
                                }
                            </th>
                            <th>
                                {
                                    this.props.lang[this.props.lang.locales]
                                        .contents.claim.redeemInfo.table.reward
                                }
                            </th>
                            <th />
                            <th>
                                {
                                    this.props.lang[this.props.lang.locales]
                                        .contents.claim.redeemInfo.table.value
                                }
                            </th>
                            <th>
                                {
                                    this.props.lang[this.props.lang.locales]
                                        .contents.claim.redeemInfo.table.point
                                }
                            </th>
                            <th>
                                {
                                    this.props.lang[this.props.lang.locales]
                                        .contents.claim.redeemInfo.table.status
                                }
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map(
                            (
                                {
                                    UTCCreated,
                                    Category,
                                    Name,
                                    NameEn,
                                    TotalValue,
                                    TotalPoints,
                                    ApprovalStatus
                                },
                                i
                            ) => (
                                <tr key={i}>
                                    <td>
                                        {moment(UTCCreated).format(
                                            "DD MMM YYYY hh:mm:ss"
                                        )}
                                    </td>
                                    <td>{Category}</td>
                                    <td>{locales === "en" ? NameEn : Name}</td>
                                    <td>
                                        {TotalValue > 0
                                            ? new Intl.NumberFormat(
                                                  "en-US"
                                              ).format(TotalValue)
                                            : `-`}
                                    </td>
                                    <td>
                                        {new Intl.NumberFormat("en-US").format(
                                            TotalPoints
                                        )}
                                    </td>
                                    <td>{ApprovalStatus}</td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>
                {count > 0 && (
                    <div className="footer">
                        <div className="row">
                            <div className="col-xs-6">
                                <div
                                    className="showing"
                                    dangerouslySetInnerHTML={{
                                        __html: this.props.lang[
                                            this.props.lang.locales
                                        ].misc.table.show
                                            .replace("{start}", start)
                                            .replace("{end}", end)
                                            .replace("{count}", count)
                                    }}
                                />
                            </div>
                            <div className="col-xs-6">
                                <nav aria-label="Page navigation">
                                    <ul className="pagination">
                                        <li>
                                            <a
                                                href="#/"
                                                aria-label="Previous"
                                                onClick={this.handleClick(
                                                    page === 1 ? page : page - 1
                                                )}
                                            >
                                                <i className="glyphicon glyphicon-menu-left" />
                                                {
                                                    this.props.lang[
                                                        this.props.lang.locales
                                                    ].misc.table.previous
                                                }
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="#/"
                                                aria-label="Next"
                                                onClick={this.handleClick(
                                                    [0, page].includes(
                                                        Math.ceil(
                                                            count / perPage
                                                        )
                                                    )
                                                        ? page
                                                        : page + 1
                                                )}
                                            >
                                                {
                                                    this.props.lang[
                                                        this.props.lang.locales
                                                    ].misc.table.next
                                                }
                                                <i className="glyphicon glyphicon-menu-right" />
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        redemptions: state.redemptions,
        lang: state.lang
    };
};

const mapDispatchToProps = (dispatch, ownProp) => {
    return {
        fetch: () => dispatch(fetch()),
        reset: () => dispatch(reset()),
        setPagination: payload => dispatch(setPagination(payload)),
        onLangSwitch: locales => e => {
            e.preventDefault();
            return dispatch(setLocales(locales));
        }
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TableRedemption);
